import Vue from 'vue';
import Vuetify, {
  VSnackbar, VBtn, VIcon, VRow, VCol, VSpacer, VBreadcrumbs, VTextField,
  VCard, VCardText, VCardActions, VCardTitle, VCardSubtitle,
  VSelect, VDatePicker, VMenu, VProgressCircular, VDialog,
  VList, VListItem, VListItemAction, VListItemContent, VListItemGroup,
  VListItemSubtitle, VListItemTitle, VToolbarTitle, VToolbar,
  VChip, VChipGroup, VTooltip, VAutocomplete, VContainer, VContent, VBadge,
  VTextarea, VTimeline, VTimelineItem, VDivider, VRating,
  VListItemIcon, VTabItem, VTabsItems, VTabs, VTab, VImg, VSubheader, VCalendar,
  VCalendarDaily, VCalendarWeekly, VCalendarMonthly, VSheet, VModel,
} from 'vuetify/lib';
import VuetifyToast from '@/components/toast';

Vue.use(Vuetify, {
  components: {
    VSnackbar,
    VBtn,
    VIcon,
    VRow,
    VCol,
    VSpacer,
    VBreadcrumbs,
    VTextField,
    VCard,
    VCardText,
    VCardActions,
    VCardTitle,
    VCardSubtitle,
    VSelect,
    VDatePicker,
    VMenu,
    VProgressCircular,
    VDialog,
    VList,
    VListItem,
    VListItemAction,
    VListItemContent,
    VListItemGroup,
    VListItemSubtitle,
    VListItemTitle,
    VToolbarTitle,
    VToolbar,
    VChip,
    VChipGroup,
    VTooltip,
    VAutocomplete,
    VContainer,
    VContent,
    VBadge,
    VTextarea,
    VTimeline,
    VTimelineItem,
    VDivider,
    VRating,
    VListItemIcon,
    VTabItem,
    VTabsItems,
    VTabs,
    VTab,
    VImg,
    VSubheader,
    VCalendar,
    VCalendarDaily,
    VCalendarWeekly,
    VCalendarMonthly,
    VSheet,
    VModel,
  },
});

const veutifyObj = new Vuetify({
  lang: {
    current: 'pt',
  },
});

Vue.use(VuetifyToast, {
  $vuetify: veutifyObj.framework,
  x: 'center',
  y: 'bottom',
  timeout: 8000,
  color: null,
  showClose: true,
  closeText: 'Fechar',
});

export default veutifyObj;
